import React, { createContext, useContext, useState } from "react";
import Notification from "../../elements/notification/Notification";
import { Helmet } from "react-helmet-async";
import TransferTabsContainer from "./TransferTabsContainer";
import TransferDialog from "../../elements/transferDialog/TransferDialog";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../App";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTransferWrapper } from "./styledTransfer";

export const TransferContainerContext = createContext({});

const TransferContainer = () => {
  const { t } = useTranslation("transferPage");
  const { user } = useContext(AppContext);

  const [refetch, setRefetch] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <TransferContainerContext.Provider
        value={{
          notification,
          setNotification,
          currentUserEmail: user.email
        }}
      >
        <StyledContentWrapper>
          <Helmet>
            <title>{t("meta.title")}</title>
          </Helmet>
          <StyledTransferWrapper>
            <TransferDialog
              setRefetch={setRefetch}
              refetch={refetch}
            />
            <TransferTabsContainer
              refetch={refetch}
              setRefetch={setRefetch}
            />
          </StyledTransferWrapper>
        </StyledContentWrapper>
      </TransferContainerContext.Provider>
    </>
  );
};

export default TransferContainer;